<style scoped>
.file {
  visibility: hidden;
  position: absolute;
}
.browse {
  background-color: #1a3665 !important;
  color: white;
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  background-color: #1a3665 !important;
  color: white !important;
  word-wrap: break-word !important;
  white-space: normal !important;
}
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-primary {
  background-color: #1a3665 !important;
}
.upload-btn-wrapper {
  width:100%;
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.ck-editor__editable {
    min-height: 200px;
}

.btn-upload {
  width:50%;

  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 5px 15px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 30px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.collapse-arrow .feather-icon {
  transform: rotate(-180deg);
  transition: 0.3s transform ease-in-out;
  display: inline-block;
}

.collapsed .collapse-arrow .feather-icon {
  transform: rotate(0deg);
}
</style>
<template>
  <div class="card">
    <div class="card-header bg-primary font-weight-bold text-white d-flex align-items-center">
      Pelatihan Offline
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
        <!-- @click="$router.go(-1)" -->
    </div>
    <form @submit.prevent="postData" id="formidentify">
      <div class="card-body">
        <div class="card border-0 shadow p-2">
          <div class="card-body">
            <div class="form-row">
              <div class="form-group col-md-12">
                <center>
                  <img
                    :src="lihat_foto  ? lihat_foto : '/img/placeholder-image.png'"
                    style="height:220px"
                    class=" img img-fluid img-responsive elevation-2 border"
                    alt="User Picture"
                  />
                  <br>
                  <span class="text-danger">*Format Gambar(PNG), Ukuran 500 x 850</span>

                  <div class="mt-2">
                    <div class="upload-btn-wrapper">
                      <input type="file" id="fileUpload" name="myfile" @change="uploadFlyer($event)" ref="refFlyer" />
                      <button class="btn-upload" type="button" @click="chooseFiles()" > Unggah Flyer</button>
                    </div>
                  </div>
                  <div class="text-danger" v-if="$v.formData.flyer.$error">
                   Flyer Harus Dipilih!
                  </div>
                </center>
              </div>
              <div class="form-group col-md-12">
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="name" class="font-weight-bold">Nama Pelatihan</label>
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      required
                      v-model="formData.namaPelatihan"
                      placeholder="Masukkan Nama Pelatihan"
                      :class="{
                        'is-invalid': $v.formData.namaPelatihan.$error,
                      }"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="kapa" class="font-weight-bold">Deskripsi Pelatihan</label>
                <!-- <textarea
                  v-model="formData.deskripsiPelatihan"
                  class="form-control"
                  id="kapa"
                  required
                  rows="5"                  
                  placeholder="Masukkan Deskripsi"
                :class="{
                    'is-invalid': $v.formData.deskripsiPelatihan.$error,
                  }"/> -->
                  <ckeditor 
                    :editor="editor" 
                    id="soalPostTest"
                    :class="{
                      'is-invalid': $v.formData.deskripsiPelatihan.$error, 
                    }"
                    @input="setDeskripsi($event)"
                    v-model="formData.deskripsiPelatihan" 
                    :config="editorConfig" 
                    rows="30" 
                    >
                  </ckeditor>  
              </div>
              <div class="form-group col-md-12">
                <label for="kapa" class="font-weight-bold">Penyelenggara</label>
                <select class="form-control" name id v-model="formData.idPenyelenggara" required>
                  <option value="" selected disabled>Pilih Penyelenggara</option>
                  <option
                    v-for="(value, index) in penyelenggara"
                    :value="value.id_penyelenggara"
                    v-bind:key="index"
                  >{{ value.nama_penyelenggara ? value.nama_penyelenggara: '-'}}</option>
                </select>
              </div>

              <div class="form-group col-md-12">
                <label for="kapa" class="font-weight-bold">Link Kuesioner</label>
                <input type="text" class="form-control" v-model="formData.linkKuesioner" required>
              </div>
              <div class="form-group col-md-12">
                <label for="kapa" class="font-weight-bold">Durasi</label>
                <input type="text" name=""  class="form-control" id="" v-model="formData.durasi">
              </div>
            </div>
            
            
            <div class="row">
              <div class="form-group col-md-12">
                <label for="tempat_pelatihan" class="font-weight-bold">Tempat Pelatihan</label>
                <textarea 
                  name="tempat_pelatihan" 
                  id="tempat_pelatihan" 
                  class="form-control"
                  v-model="formData.namaTempatPelatihan"
                  placeholder="Masukkan Nama Tempat Pelatihan"
                  cols="30" 
                  required
                  rows="5">
                </textarea>
                
              </div>
              <div class="form-group col-md-12">
                <label for="pos" class="font-weight-bold">Kota/Kabupaten</label>
                <multiselect
                  label="name"
                  placeholder="Pilih Kota/Kab"
                  id="kotaKab"
                  @select="updateSelect"
                  v-model="datakotakab"
                  :options="KotaKab"
                ></multiselect>
              </div>
            </div>
          </div>
        </div>  
        <!-- Form Materi Pelatihan -->
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-muted h4">Materi Pelatihan</div>

          <div class="card-body">
            <div class="form-row">
              <div class="form-group col-md-11">
                <label for="kapa" class="font-weight-bold">Link Materi</label>
                <input 
                  type="text" 
                  class="form-control"
                  placeholder="Masukkan link materi"
                  v-model="formData.linkMateri"
                >
              </div>
            </div>
            <div class="form-row" v-for="(input,k) in formData.pelatihanMateri" :key="k">
              <div class="form-group col-md-6">
                <label for="pos" class="font-weight-bold">Nama Materi</label>
                <input 
                  type="text" 
                  v-model="input.namaMateri" 
                  placeholder="Masukkan Nama Materi" 
                  class="form-control"
                >
              </div>
              <div class="form-group col-md-5">
                <label for="pos" class="font-weight-bold">File</label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input text-truncate"
                    id="customFileLangHTML"
                    ref="uploadFileMasterDokumen"
                    @change="fileUpload($event,k)"
                  />
                  <label
                    class="custom-file-label text-truncate"
                    for="customFileLangHTML"
                    data-browse="Unggah"
                  >{{ typeof input.fileName === "string" ? input.fileName : fileName }}</label>
                </div>
                <small class="text-danger">(*File harus bertipe PDF max. 10MB)</small>
              </div>
              <div class="col-1 d-flex align-items-center mt-3">
                <div
                  class="btn btn-sm btn-success ml-2"
                  @click="add_materi(k)"
                  style="margin-bottom: 22px"
                  v-show="k == formData.pelatihanMateri.length-1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2"
                  style="margin-bottom: 22px"
                  @click="remove_materi(k)"
                  v-show="k || ( !k && formData.pelatihanMateri.length > 1)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Form Materi Pelatihan -->
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-muted h4">Jadwal Pelaksanaan Pelatihan</div>

          <div class="card-body" v-for="(input,k) in formData.jadwalPelatihanRequest" :key="k">
            <div class="form-row">
              
              <div class="form-group col-md-5">
                <label for="pos" class="font-weight-bold">Tanggal Pelaksanaan</label>
                <input
                  type="date"
                  class="form-control"                  
                  id="pos"
                  required
                  v-model="input.tanggal"
                  placeholder="Pilih Tanggal "
                />
              </div>
              <div class="form-group col-md-3">
                <label for="" class="font-weight-bold">Waktu Dimulai</label>
                <input type="time" class="form-control" v-model="input.waktuDimulai" id="" required>
              </div>
              <div class="form-group col-md-3">
                <label for="" class="font-weight-bold">Waktu Berakhir</label>
                <input type="time" class="form-control" :min="input.waktuDimulai" v-model="input.waktuBerakhir" id="" required>
              </div>
              <div class="col-1 d-flex align-items-center mt-3">
                <div
                  class="btn btn-sm btn-success ml-2"
                  @click="add_jadwal(k)"
                  v-show="k == formData.jadwalPelatihanRequest.length-1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2"
                  @click="remove_jadwal(k)"
                  v-show="k || ( !k && formData.jadwalPelatihanRequest.length > 1)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
            
          </div>
        </div>
        <!-- End Jadwal Pelaksanaan Pelatihan -->

        <!-- Katalog -->
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-muted h4">Katalog Pelatihan</div>
          <div class="card-body">
            <div class="form-row" v-for="(input,k) in formData.pelatihanKatalog" :key="k">
              <div class="form-group col-md-5">
                <label for="pos" class="font-weight-bold">Katalog</label>
                  <multiselect
                    label="kodePelatihan"
                    placeholder="Pilih Kode Pelatihan"
                    id="kodepelatihan"
                    @input="(value) => pilihKatalog(value, k)"
                    v-model="input.katalogModel"
                    :options="optionKodePelatihan"
                  ></multiselect>
              </div>
              <div class="form-group col-md-3">
                <p class="mb-2 text-muted font-weight-bold mb-2">Terstruktur</p>
                <input
                  type="number"
                  v-model="input.skpTerstruktur"
                  class="form-control text-center"                  
                  style="height: 42px"
                  min="0"
                  required
                />
              </div>
              <div class="form-group col-md-3">
                <p class="mb-2 text-muted font-weight-bold mb-2">Non Terstruktur</p>
                <input
                  type="number"
                  v-model="input.skpNonTerstruktur"
                  class="form-control text-center"                  
                  style="height: 42px"
                  min="0"
                  required
                />
              </div>
              
              <div class="col-1 d-flex align-items-center mt-3">
                <div
                  class="btn btn-sm btn-success ml-2"
                  @click="add_katalog(k)"
                  v-show="k == formData.pelatihanKatalog.length-1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2"
                  @click="remove_katalog(k)"
                  v-show="k || ( !k && formData.pelatihanKatalog.length > 1)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Pengaturan Assesment -->
        <div class="card border-0 shadow p-2">  
          <div class="card-header bg-white text-muted h4">Pengaturan SKP Assessment</div>
          <div class="card-body">
            <div class="form-row" v-for="(input,k) in formData.pengaturanAssessment" :key="k">
              
              <div class="form-group col-md-3">
                <label for="pos" class="font-weight-bold">Range Nilai</label>
                <input
                  type="number"
                  min="0"
                  class="form-control"                
                  v-model="input.rangeSatu"
                  id="pos"                
                  required  
                  placeholder="Masukkan Nilai"
                />
              </div>
              <div class="form-group col-md-3">
                <label for="pos" class="font-weight-bold"></label>
                <input
                  type="number"
                  min="0"
                  class="form-control mt-2"                  
                  v-model="input.rangeDua"
                  id="pos"                 
                  required 
                  placeholder="Masukkan Nilai"
                />
              </div>
              <div class="form-group col-md-5 ">
                <label for="pos" class="font-weight-bold">Perolehan SKP</label>
                <input
                  type="number"
                  min="0"
                  required
                  class="form-control"
                  id="pos"                         
                  v-model="input.assessment"           
                />
              </div>
            
              <div class="col-1 d-flex align-items-center mt-3">
                <div
                  class="btn btn-sm btn-success ml-2"
                  @click="add_pengaturan_asessment(k)"
                  v-show="k == formData.pengaturanAssessment.length-1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2"
                  @click="remove_pengaturan_asessment(k)"
                  v-show="k || ( !k && formData.pengaturanAssessment.length > 1)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>            
            </div>
          </div>
        </div>
        <!-- End Pengaturan Assesment -->

        <!-- Instruktur -->
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-muted h4">Instruktur Pelatihan</div>
          <div class="card-body">
            <div class="form-row" v-for="(input,k) in formData.pelatihanInstruktur" :key="k">
              <div class="form-group col-md-11">
                <label for="pos" class="font-weight-bold">Instruktur</label>
                <multiselect
                  label="namaInstruktur"
                  placeholder="Pilih Instruktur"
                  v-model="input.modelMultiSelect"
                  @input="(value) => pilihInstuktur(value, k)"
                  :options="dat_instruktur"
                  :custom-label="customLabel">
                    <template slot="option"  slot-scope="{ option }">{{ option.namaInstruktur ? option.namaInstruktur + ' -' : '' }} {{ option.tipeInstruktur ?  option.tipeInstruktur : 'IAPI'}}</template>
                  </multiselect>
              </div>
              <div class="col-1 d-flex align-items-center mt-2">
                <div
                  class="btn btn-sm btn-success ml-2"
                  @click="add(k)"
                  v-show="k == formData.pelatihanInstruktur.length-1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2"
                  @click="remove(k)"
                  v-show="k || ( !k && formData.pelatihanInstruktur.length > 1)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-row" v-for="(inputKatalog,iK) in formData.pelatihanKatalog" :key="iK"  v-show="input.showKatalog">
                  <div class="form-group col-md-4">
                    <label for="" class="font-weight-bold">Nama Katalog </label>
                    <input type="text" class="form-control" readonly :value="inputKatalog.namaKatalog">
                    
                  </div>
                  <div class="form-group col-md-4">
                    <label for="" class="font-weight-bold">Terstruktur </label>
                    <input type="number" class="form-control" v-model="formData.pelatihanInstruktur[k].katalogInstruktur[iK].skpTerstrukturKatalog" required>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="" class="font-weight-bold">Non Terstruktur</label>
                    <input type="number" class="form-control" v-model="formData.pelatihanInstruktur[k].katalogInstruktur[iK].skpNonTerstrukturKatalog" required>
                  </div>
                </div>
              </div>
              
              
            </div>
          </div>
        </div>
        <!-- End Instruktur -->

        <!-- Moderator -->
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-muted h4">Moderator</div>
          <div class="card-body">
            <div class="form-row" v-for="(input,k) in formData.pelatihanModerator" :key="k">
              <div class="form-group col-md-11">
                <label for="pos" class="font-weight-bold">Moderator</label>
                <multiselect
                  label="namaInstruktur"
                  placeholder="Pilih Moderator"
                  v-model="input.modelMultiSelect"
                  @input="(value) => pilihModerator(value, k)"
                  :custom-label="customLabel"
                  :options="dat_instruktur">
                    <template slot="option"  slot-scope="{ option }">{{ option.namaInstruktur ? option.namaInstruktur + ' -' : '' }} {{ option.tipeInstruktur ?  option.tipeInstruktur : 'IAPI'}}</template>
                  </multiselect>
              </div>
              <div class="col-1 d-flex align-items-center mt-2">
                <div
                  class="btn btn-sm btn-success ml-2"
                  @click="add_moderator(k)"
                  v-show="k == formData.pelatihanModerator.length-1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2"
                  @click="remove_moderator(k)"
                  v-show="k || ( !k && formData.pelatihanModerator.length > 1)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-row" v-for="(inputKatalog,iK) in formData.pelatihanKatalog" :key="iK"  v-show="input.showKatalog">
                  <div class="form-group col-md-4">
                    <label for="" class="font-weight-bold">Nama Katalog </label>
                    <input type="text" class="form-control" readonly :value="inputKatalog.namaKatalog">
                    
                  </div>
                  <div class="form-group col-md-4">
                    <label for="" class="font-weight-bold">Terstruktur</label>
                    <input type="number" class="form-control" v-model="formData.pelatihanModerator[k].katalogModerator[iK].skpTerstrukturKatalog" >
                  </div>
                  <div class="form-group col-md-4">
                    <label for="" class="font-weight-bold">Non Terstruktur</label>
                    <input type="number" class="form-control" v-model="formData.pelatihanModerator[k].katalogModerator[iK].skpNonTerstrukturKatalog" >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Biaya Pelatihan -->
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-muted h4">Biaya Pelatihan</div>
          <div class="card-body">
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="pos" class="font-weight-bold">Biaya Pelatihan</label>
                <select
                  v-model="formData.statusBiaya"
                  class="form-control"
                  required
                  name                  
                  id="tipe_biaya"
                  @change="tipe_biaya($event)">
                  <option value="gratis" selected>Gratis</option>
                  <option value="berbayar">Berbayar</option>
                </select>
              </div>
              <div class="form-group col-md-12 mb-0">
                <label for="pos" class="font-weight-bold">Jumlah Kursi</label>
              </div>
              <div class="form-group col-md-4">
                <input
                  type="number"
                  v-model="formData.jumlahKursiAP"
                  class="form-control"
                  required
                  min="0"
                  id="pos"                  
                  placeholder="AP"
                />
              </div>
              <div class="form-group col-md-4">
                <input
                  type="number"                  
                  v-model="formData.jumlahKursiNonAP"
                  class="form-control"
                  min="0"
                  required
                  id="fax"
                  placeholder="Non AP"
                />
              </div>
              <div class="form-group col-md-4">
                <input
                  type="number"
                  v-model="formData.jumlahKursiUmum"
                  class="form-control"
                  min="0"                  
                  required
                  id="fax"
                  placeholder="Umum"
                />
              </div>
              <div class="form-group col-md-4">
                <p class="form-text font-weight-bold mb-2">Biaya Anggota AP</p>
                <vue-autonumeric
                  class="form-control"
                  :options="{
                    minimumValue: '0'
                  }"
                  :required="formData.statusBiaya == 'berbayar'"
                  id="agtAp"                  
                  :disabled="statusBayar == true && formData.jumlahKursiAP > 0  ? false : true"
                  v-model="formData.biayaAnggotaAp"
                  placeholder="Masukkan Jumlah"
                ></vue-autonumeric>
             
              </div>
              <div class="form-group col-md-4">
                <p class="form-text font-weight-bold mb-2">Biaya Anggota Non AP</p>
                <vue-autonumeric
                  class="form-control"
                  :options="{
                    minimumValue: '0'
                  }"
                  id="agtNonAp"                
                  :disabled="statusBayar == true && formData.jumlahKursiNonAP > 0  ? false : true"
                  v-model="formData.biayaAnggotaNonAp"
                  placeholder="Masukkan Jumlah"
                  :required="formData.statusBiaya == 'berbayar'"

                ></vue-autonumeric>
            
              </div>
              <div class="form-group col-md-4">
                <p class="form-text font-weight-bold mb-2">Biaya Umum</p>
                <vue-autonumeric
                  class="form-control"
                  :options="{
                    minimumValue: '0'
                  }"
                  id="umum"                  
                  v-model="formData.biayaUmum"
                  :required="formData.statusBiaya == 'berbayar'"
                  :disabled="statusBayar == true && formData.jumlahKursiUmum > 0  ? false : true"
                  placeholder="Masukkan Jumlah"
                ></vue-autonumeric>                
              </div>
              <div class="form-group col-md-12">
                <p class="form-text font-weight-bold mb-2">Disclaimer</p>
                <ckeditor 
                  :editor="editor" 
                  id="soalPostTest"
                 
                  @input="setDisclaimer($event)"
                  v-model="formData.disclaimer" 
                  :config="editorConfig" 
                  rows="5" 
                  >
                </ckeditor>  
                <!-- <textarea class="form-control" cols="30" rows="10" v-model="formData.disclaimer"></textarea> -->
              </div>
            </div>
            
          </div>
        </div>
        <!--End Biaya Pelatihan -->    

        <!-- Sertifikat -->
       
        <!-- End Sertifikat -->
        
        <!-- Pengaturan -->
        <div class="card border-0 shadow p-2">
          <div class="card-header">
            <label for="pos" class="font-weight-bold">Pengaturan</label>
          </div>
          <div class="card-body">
            <div class="form-row">
              <CCol sm="12" class="mt-3">
                <div class="d-flex align-items-center">
                  <label for class="font-weight-bold mb-0 col-3 pl-0">Dokumen Persyaratan</label>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      v-model="formData.statusDokumenPersyaratan"
                      class="custom-control-input"
                      name="persyaratan"
                      id="ya"
                      :value="'1'"
                      required
                    />
                    <label class="custom-control-label" for="ya">Ya</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      v-model="formData.statusDokumenPersyaratan"
                      class="custom-control-input"
                      name="persyaratan"
                      id="tidak"
                      :value="'0'"
                      required
                    />
                    <label class="custom-control-label" for="tidak">Tidak</label>
                  </div>
                </div>
              </CCol>
              <CCol sm="12" class="mt-3">
                <div class="d-flex align-items-center">
                  <label for class="font-weight-bold mb-0 col-3 pl-0">Keharusan Approval</label>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      v-model="formData.statusKeharusanApproval"
                      class="custom-control-input"
                      name="approval"
                      id="approved"
                      required
                      :value="'1'"
                    />
                    <label class="custom-control-label" for="approved">Ya</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      class="custom-control-input"
                      name="approval"
                      :value="'0'"
                      required
                      v-model="formData.statusKeharusanApproval"
                      id="non_approved"
                    />
                    <label class="custom-control-label" for="non_approved">Tidak</label>
                  </div>
                </div>
              </CCol>
              <CCol sm="12" class="mt-3">
                <div class="d-flex align-items-center">
                  <label for class="font-weight-bold mb-0 col-3 pl-0">Status Pengumuman SKP</label>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      v-model="formData.statusPengumumanSkp"
                      class="custom-control-input"
                      name="announcementskp"
                      id="announcementskp"
                      required
                      :value="'1'"
                    />
                    <label class="custom-control-label" for="announcementskp">Ya</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      class="custom-control-input"
                      name="announcementskp"
                      :value="'0'"
                      required
                      v-model="formData.statusPengumumanSkp"
                      id="non_announcementskp"
                    />
                    <label class="custom-control-label" for="non_announcementskp">Tidak</label>
                  </div>
                </div>
              </CCol>
              <CCol sm="12" class="mt-3">
                <div class="d-flex align-items-center">
                  <label for class="font-weight-bold mb-0 col-3 pl-0">Status</label>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      v-model="formData.status"
                      class="custom-control-input"
                      name="status"
                      id="aktif"
                      required
                      :value="'1'"
                    />
                    <label class="custom-control-label" for="aktif">Aktif</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      class="custom-control-input"
                      name="status"
                      id="tidak_aktif"
                      required
                      :value="'0'"
                      v-model="formData.status"
                    />
                    <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                  </div>
                </div>
              </CCol>
            </div>
          </div>
        </div>
        <!-- End Pengaturan -->
        <!-- Form Dokumen Upload -->
        <div class="card border-0 shadow p-2" id="divdokumen" v-show="formData.statusDokumenPersyaratan == '1'">
          <div class="card-header bg-white text-muted h4">
            Dokumen Persyaratan
          </div>
          <div class="card-body">
            <div
              class="form-row"
              v-for="(input,
              k) in formData.pelatihanDokumen"
              :key="k"
            >
              <div class="form-group col-md-5">
                <label for="kode_dok" class="font-weight-bold">Dokumen</label>
                <multiselect
                  label="namaDokumen"
                  placeholder="Pilih Dokumen"
                  v-model="input.modelMultiSelect"                  
                  @input="(value) => pilihDokumen(value, k)"
                  :options="optionMasterDokumen"
                ></multiselect>
                <div class="text-danger" v-if="input.invalid_dokumen">
                  Dokumen Harus Dipilih.
                </div>
              </div> 
              <div class="form-group col-md-5">
                <label for="nama_dok" class="font-weight-bold">Status Wajib Dokumen</label>                
                <select 
                  class="form-control"
                  v-model="input.statusRequired"   
                  :required="formData.statusDokumenPersyaratan=='1'"
                  style="height: 42px">
                  <option value="1">Wajib</option>
                  <option value="0">Tidak Wajib</option>
                </select>
              </div>

              <div class="col-2 d-flex align-items-center">
                <div
                  class="btn btn-sm btn-success ml-2 mt-2"
                  @click="add_dokumen(k)"
                  v-show="
                    k ==
                    formData.pelatihanDokumen.length - 1
                  "
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2 mt-2"
                  @click="remove_dokumen(k)"
                  v-show="
                    k ||
                    (!k &&
                      formData.pelatihanDokumen.length > 1)
                  "
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Form Dokumen Upload -->
        <div class="card border-0 shadow p-2" id="divdokumen" v-show="formData.statusPengumumanSkp == '1'">
          <div class="card-header bg-white text-muted h4">
            Pengumuman SKP
          </div>
          <div class="card-body">
          
            <div class="form-group col-md-12">
              <label for="kode_dok" class="font-weight-bold">Tanggal Pengumuman SKP</label>
              <input type="date" name="" id="" v-model="formData.tanggalPengumumanSkp" class="form-control">
              <div 
                class="text-danger" 
                v-if="$v.formData.tanggalPengumumanSkp.$error">
                Tanggal Pengumuman SKP
              </div> 
            </div>
              
             
            
          </div>
        </div>
      </div>
      <div class="card-footer bg-white border-0 ml-auto mb-5 mr-3 float-right">
        <Button class="btn btn-md btn-success px-4 py-2"  type="submit" color="success">Simpan</Button>
      </div>
    </form>
  </div>
</template>
<script>
import { required, minLength, requiredIf, minValue } from 'vuelidate/lib/validators'
/**
 * @Service
 */
import KotaKabupatenService from "@/services/datamaster/kota-kabupaten.service";
import PenyelenggaraService from "@/services/pelatihan/penyelenggara.service";
import InstrukturService from "@/services/pelatihan/instruktur.service";
import WorkshopService from "@/services/pelatihan/workshop.service";
import SignatureService from "@/services/pelatihan/signature.service";
import AutoNumeric from "@/../node_modules/autonumeric/src/main";
import VueAutonumeric from "@/../node_modules/vue-autonumeric/src/components/VueAutonumeric";

/**
 * @Mixins
 */
import { AlertUtils } from "@/mixins/AlertUtils"
import { KodePelatihan } from "@/mixins/master/KodePelatihan"
import { UploadImage } from '@/mixins/UploadImage'
import { MasterDokumen } from "@/mixins/master/MasterDokumen";

/**
 * @Component
 */
import TextField from "@/components/formcomponent/TextField"

/**
 * @State
 */
import StateWorkshopTambah from "./StateWorkshopTambah"
import dataSertifikasiRplService from '@/services/keanggotaan/data-sertifikasi/data-sertifikasi-rpl.service';
import { min } from 'moment';


/**
 * @Plugin
 */
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';



export default {
  mixins : [
    AlertUtils,
    KodePelatihan,
    UploadImage,
    MasterDokumen
  ],
  name: "Workshop",
  data() {
    return {
      editor: ClassicEditor,
      editorData: '',
      editorConfig: {
          // The configuration of the editor.
      },
      status_invalid: 0,
      lihat_foto : null,
      statusBayar: "",
      datakotakab: [],
      penyelenggara: [],
      dat_katalog: [],
      dat_instruktur: [],
      KotaKab: [],
      dataSignature: [],
      signature : '',
      katalogModel : '',
      kodePelatihan : '',
      form_length : 0,
      formData: {
          linkMateri: '',
          durasi : '',
          idTandaTangan: '',
          backgroundSertifikat: "",
          fileNameCertificate: 'Pilih File',
          linkKuesioner:'',
          disclaimer:'',
          tipePelatihan : 'offline',
          idKodePelatihan : '',
          tanggalPengumumanSkp : '',
          linkWebinar : [
                {
                  linkWebinar: ''
                }
              ],
          jadwalPelatihanRequest : [
              {
                  tanggal : '',
                  waktuDimulai : '',
                  waktuBerakhir : ''
              }
          ],
          pengaturanAssessment : [
              {
                  idPengaturanPelatihanAssessment : '',
                  rangeSatu : '',
                  rangeDua : '',
                  assessment : ''
              }
          ],
          materi : '',
          flyer : null,
          biaya: "",
          biayaAnggotaAp: "",
          biayaAnggotaNonAp: "",
          biayaUmum: "",
          deskripsiPelatihan: "",
          idInstruktur: "",
          idKotaKab: "",
          idPenyelenggara: "",
          idWorkshopPelatihan: "",
          jumlahKursiAP: "",
          jumlahKursiNonAP: "",
          jumlahKursiUmum: "",
          namaPelatihan: "",
          namaTempatPelatihan: "",
          noLaporPPL: "",
          deletePelatihanInstrukturRequest : [
              {
                  idDatInstrukturPelatihan : ""
              }
          ],

          deletePelatihanModeratorRequest : [
              {
                  idDatModeratorPelatihan : ''
              }
          ],
          deletePelatihanKatalogRequest : [
              {
                  idDatKatalogPelatihan : ''
              }
          ],
          pelatihanInstruktur: [
              {
                  idDatInstrukturPelatihan: "",
                  idInstrukturPelatihan: "",
                  skpAssesment: "",
                  skpNonTerstruktur: "",
                  skpTerstruktur: "",
                  showKatalog : false,
                  // katalogInstruktur : []
                  katalogInstruktur : [
                      {
                          idKatalogInstruktur : '',
                          idKatalog : '',
                          skpTerstrukturKatalog : '',
                          skpNonTerstrukturKatalog : ''
                      }
                  ]
              }
          ],
          pelatihanMateri : [
              {
                  idPelatihanMateri : '',
                  fileMateri : '',
                  fileName : 'Pilh File',
                  namaMateri : ''
              }
          ],
          pelatihanKatalog: [
              {
                  idDatKatalogPelatihan: "",
                  idKatalogPelatihan: "",
                  namaKatalog : '',
                  skpAssesment: "",
                  skpNonTerstruktur: "",
                  skpTerstruktur: "",
                  katalogModel : []
              }
          ],
          pelatihanModerator: [
              {
                  idDatModeratorPelatihan: "",
                  namaModerator: "",
                  idModerator : "",
                  skpAssesment: "",
                  skpNonTerstruktur: "",
                  skpTerstruktur: "",
                  showKatalog : "",
                  katalogModerator : [
                      {
                          idKatalogModerator : '',
                          idKatalog : '',
                          skpTerstrukturKatalog : '',
                          skpNonTerstrukturKatalog : ''
                      }
                  ]
              }
          ],
          pelatihanDokumen : [
              {
                  idDokumenPendukung : "",
                  idMasterDokumen: "",
                  statusRequired : '',
                  invalid_dokumen : false,
                  modelMultiSelect: [],
              }
          ],
          skpIapiAssesment: "",
          skpIapiNonTerstruktur: "",
          skpIapiTerstruktur: "",
          skpNonIapiNonTerstruktur: "",
          skpNonIapiTerstruktur: "",
          skpNonIapiAssesment: "",
          status: "",
          statusBiaya: "gratis",
          statusDokumenPersyaratan: "",
          statusKeharusanApproval: "",
          statusPengumumanSkp: "",
          tanggalBerakhir: "",
          tanggalDimulai: ""
      },
      instruktur: [
          {
              instruktur: "",
              terstruktur: "",
              nonTerstruktur: "",
              asessment: ""
          }
      ],
      katalog: [
        {
          katalog: "",
          terstruktur: "",
          nonTerstruktur: "",
          asessment: ""
        }
      ],
      moderator: [
          {
              moderator: "",
              terstruktur: "",
              nonTerstruktur: "",
              asessment: ""
          }
      ]
    }
  },

  validations: {
    kodepelatihan : false,
    formData: {
      flyer: { required },
      namaPelatihan: { required },
      deskripsiPelatihan: { required },
      idPenyelenggara: { required },
      namaTempatPelatihan: { required },
      idKotaKab: { required },
      tanggalPengumumanSkp : {
        required : requiredIf(function() {
          return this.formData.statusPengumumanSkp == "1"
        })
      },
      jadwalPelatihanRequest: {
        $each: {
          tanggal: { required },
          waktuBerakhir: { required },
          waktuDimulai: { required },
        }
      },
      pelatihanKatalog: {
        $each: {
          idKatalogPelatihan: { required },
          skpTerstruktur: {
            required,
            minValue: minValue(0)
          },
          skpNonTerstruktur: {
            required,
            minValue: minValue(0)
          },
        }
      },
      pengaturanAssessment: {
        $each: {
          rangeSatu: {
            required,
            minValue: minValue(0)
          },
          rangeDua: {
            required,
            minValue: minValue(0)
          },
          assessment: {
            required,
            minValue: minValue(0)
          }
        }
      },
      pelatihanInstruktur: {
        $each: {
          idInstrukturPelatihan: {
            required,
            $each: {
              katalogInstruktur: {
                $each: {
                  skpTerstrukturKatalog: {
                    required,
                    minValue: minValue(0)
                  },
                  skpNonTerstrukturKatalog: {
                    required,
                    minValue: minValue(0)
                  }
                }
              }
            }
          }        
        }
      },
      // pelatihanModerator: {
      //   $each: {
      //     idModerator: { required },
      //     katalogModerator: {
      //       $each: {
      //         idKatalog: { required },
      //         skpNonTerstrukturKatalog: {
      //           required,
      //           minValue: minValue(0)
      //         },
      //         skpTerstrukturKatalog: {
      //           required,
      //           minValue: minValue(0)
      //         }
      //       }
      //     }
      //   }
      // }
    }
  },

  watch : {
    'formData.pelatihanKatalog' : function (value) {
      var dataKatalog = this.formData.pelatihanKatalog;
      this.formData.pelatihanInstruktur.filter(function(element,index) {
        var data = []

        for (let index = 0; index < dataKatalog.length; index++) {
            var skpTerstrukturKatalog = ""
            var skpNonTerstrukturKatalog = ""
            var idKatalogInstruktur = ""

            if (typeof element.katalogInstruktur[index] !== 'undefined' && element.katalogInstruktur[index] !== null) {
                if(element.katalogInstruktur[index].skpTerstrukturKatalog != "") {
                    skpTerstrukturKatalog = element.katalogInstruktur[index].skpTerstrukturKatalog
                }

                if(element.katalogInstruktur[index].skpNonTerstrukturKatalog != "") {
                    skpNonTerstrukturKatalog = element.katalogInstruktur[index].skpNonTerstrukturKatalog
                }

                if(element.katalogInstruktur[index].idKatalogInstruktur != "") {
                  idKatalogInstruktur = element.katalogInstruktur[index].idKatalogInstruktur
                }

                data.push({
                    idKatalogInstruktur : idKatalogInstruktur,
                    idKatalog : dataKatalog[index].idKatalogPelatihan,
                    skpTerstrukturKatalog : skpTerstrukturKatalog,
                    skpNonTerstrukturKatalog : skpNonTerstrukturKatalog
                })
            } else {
              data.push({
                  idKatalogInstruktur : "",
                  idKatalog : dataKatalog[index].idKatalogPelatihan,
                  skpTerstrukturKatalog : "",
                  skpNonTerstrukturKatalog : ""
              })
            }
        }
        element.katalogInstruktur = data
      }) // end filter

      this.formData.pelatihanModerator.filter(function(element,index) {
        var data = []
        for (let index = 0; index < dataKatalog.length; index++) {
            var skpTerstrukturKatalog = ""
            var skpNonTerstrukturKatalog = ""
            var idKatalogModerator = ""
            if (typeof element.katalogModerator[index] !== 'undefined' && element.katalogModerator[index] !== null) {
              if(element.katalogModerator[index].skpTerstrukturKatalog != "") {
                  skpTerstrukturKatalog = element.katalogModerator[index].skpTerstrukturKatalog
              }

              if(element.katalogModerator[index].skpNonTerstrukturKatalog != "") {
                  skpNonTerstrukturKatalog = element.katalogModerator[index].skpNonTerstrukturKatalog
              }

              if(element.katalogModerator[index].idKatalogModerator != "") {
                idKatalogModerator = element.katalogModerator[index].idKatalogModerator
              }

              data.push({
                  idKatalogModerator : idKatalogModerator,
                  idKatalog : dataKatalog[index].idKatalogModerator,
                  skpTerstrukturKatalog : skpTerstrukturKatalog,
                  skpNonTerstrukturKatalog : skpNonTerstrukturKatalog
              })
            } else {
              data.push({
                  idKatalogModerator : "",
                  idKatalog : dataKatalog[index].idKatalogModerator,
                  skpTerstrukturKatalog : "",
                  skpNonTerstrukturKatalog : ""
              })
            }
        }

        element.katalogModerator = data
      }) // end filter
    }
  },
  components: {
    VueAutonumeric,
    TextField
  },
  mounted() {
    this.getAllDokumen();
    this.getKotaKab();
    this.getDataPenyelenggara();
    this.getDataKatalog();
    this.getDataInstruktur();
    this.getDataSignature();
    this.getAllKodePelatihan();
  },
  methods: { 
    setDisclaimer(value) {
      this.formData.disclaimer = value;
    },
    setDeskripsi(value) {
      this.formData.deskripsiPelatihan = value
    }, 
    customLabel ({ namaInstruktur, tipeInstruktur }) {
      return `${namaInstruktur} - ${tipeInstruktur}`
    },
    chooseFiles: function() {
      document.getElementById('fileUpload').click()
    },
    pilihDokumen(value, k) {
      if (value.idMasterDokumen != null) {
        this.formData.pelatihanDokumen[
          k
        ].invalid_dokumen = false;
        for (
          let index = 0;
          index < this.formData.pelatihanDokumen.length;
          index++
        ) {
          var idMasterDokumen = this.formData
            .pelatihanDokumen[index].idMasterDokumen;
          var idSelectMasterDokumen = value.idMasterDokumen;
          if (idMasterDokumen == idSelectMasterDokumen) {
            this.alertError("Tidak Boleh Ada Dokumen Yang Sama");
            return false;
          }
        }
        this.formData.pelatihanDokumen[
          k
        ].idMasterDokumen = value.idMasterDokumen;
      } else {
        this.formData.pelatihanDokumen[
          k
        ].idMasterDokumen = "";
      }
    },

    inputSkp(e,k,iK) {
      this.formData.pelatihanInstruktur[k].katalogInstruktur[iK].skpTerstrukturKatalog = e.target.value
      
    },
    returnIndex(index) {
      return index+=1;
    },

    fileUpload(e, index) {
      var typeDok = e.target.files[0].type;
      var typeDokumen = typeDok.split("/");
      // comment console console.log(e.target.value)
      if (typeDokumen[1] != "pdf") {
        this.alertError("Dokumen Harus Bertipe PDF");
        return false;
      } else {
        this.formData.pelatihanMateri[index].fileMateri =
          e.target.files[0];
        this.formData.pelatihanMateri[index].fileName =
          e.target.files[0].name;
      }
    },

    fileUploadBgCertificate(event) {
      var typeDok = event.target.files[0].type;
      var typeDokumen = typeDok.split("/");
      // comment console console.log(event.target.value)
      if (typeDokumen[1] != "png") {
        this.alertError("Dokumen Harus Bertipe PNG");
        return false;
      } else {
        this.formData.backgroundSertifikat = event.target.files[0];
        this.formData.fileNameCertificate = event.target.files[0].name;
      }
    },

    pilihTanggalBerakhir() {
      this.formData.jadwalPelatihanRequest = []
      const date1 = moment(this.formData.tanggalDimulai);
      // new Date(this.formData.tanggalDimulai);
      const date2 = moment(this.formData.tanggalBerakhir);
      const diffTime = Math.abs(date2 - date1);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
      this.form_length = diffDays ;
      // comment console console.log(diffTime + " milliseconds");
      // comment console console.log(diffDays + " days" + date1);
      var lenght = diffDays + 1;
      // comment console console.log(lenght)
      for (let index = 0; index < lenght; index++) {
        // const element = array[index];
        var hari = index;
        this.formData.jadwalPelatihanRequest.push({
          waktuDimulai : '',
          waktuBerakhir :'',
          hari : hari+=1
        })
      }
    },
    pilihKodePelatihan(value) {
      // comment console console.log(value);
      if(value != null) {
        this.validation.kodepelatihan = true
      }
      this.formData.idKodePelatihan = value.idKodePelatihan;
    },

    pilihKatalog(event, k) {
      var data = event.idKodePelatihan;
      
      for (
        let index = 0;
        index < this.formData.pelatihanKatalog.length;
        index++
      ) {
        var idKatalogPelatihan = this.formData.pelatihanKatalog[index].idKatalogPelatihan;
        var idSelectKatalog = data;

        if (idKatalogPelatihan == idSelectKatalog) {
          this.alertError("Tidak Boleh Ada Katalog Yang Sama");

          return false;
        }
      }
      this.formData.pelatihanKatalog[k].idKatalogPelatihan = data;
      this.formData.pelatihanKatalog[k].namaKatalog = event.kodePelatihan;  

    },

    pilihInstuktur(value, k) {
      // alert(value.idInstruktur)
      var data = value.idInstruktur;
      this.formData.pelatihanInstruktur[k].showKatalog = true;
      var status_invalid_form = 0;
      
      var status_invalid_data = this.status_invalid;      
      for ( let index = 0;  index < this.formData.pelatihanInstruktur.length; index++) {
        var idInstrukturPelatihan = this.formData.pelatihanInstruktur[index].idInstrukturPelatihan;
        var idSelectInstruktur = data;
        // this.status_invalid += 1
        // alert(status_invalid += 1)

        if (idInstrukturPelatihan == idSelectInstruktur) {
            status_invalid_form += 1;
        }
      }

      if(status_invalid_form > 0) {
        this.alertError("Tidak Boleh Ada Instruktur Yang Sama");
        this.formData.pelatihanInstruktur[k].idInstrukturPelatihan = ''
        this.formData.pelatihanInstruktur[k].modelMultiSelect = []
        return false;
      }

      this.cekInstruktur(data, k , "instruktur");

    },

    cekInstruktur(data, k, jenis) {
      var status_invalid = 0;
      if(jenis == "instruktur") {
        this.formData.pelatihanModerator.filter((element) => {
          var idElement =  element.idModerator;
          var idSelect = data;
          if(idElement == idSelect) {
            status_invalid += 1;
          }  
        });
        if(status_invalid > 0) {
          this.alertError("Instruktur dan Moderator Tidak Boleh Ada Yang Sama");
          this.formData.pelatihanInstruktur[k].idInstrukturPelatihan = ''
          this.formData.pelatihanInstruktur[k].modelMultiSelect = []
          return false
        } else {
          this.formData.pelatihanInstruktur[k].idInstrukturPelatihan = data;
        }
      } else if(jenis == "moderator") {
        this.formData.pelatihanInstruktur.filter((element) => {
          var idElement =  element.idInstrukturPelatihan;
          var idSelect = data;
          if(idElement == idSelect) {
            status_invalid += 1;
          }  
        });
        if(status_invalid > 0) {
          this.alertError("Moderator dan Instruktur Tidak Boleh Ada Yang Sama");
          this.formData.pelatihanModerator[k].idModerator = ''
          this.formData.pelatihanModerator[k].modelMultiSelect = []
          return false;
        } else {
          this.formData.pelatihanModerator[k].idModerator = data
        }
      }

    },

    pilihModerator(value, k) {
      var data = value.idInstruktur;
      // comment console console.log(value)
      this.formData.pelatihanModerator[k].showKatalog = true;
     
      var status_invalid_form = 0;
      var status_invalid_data = this.status_invalid;
      var vm = this;
      this.formData.pelatihanModerator.filter((element, index) => {
        // comment console console.log('id instruktur element'+element.idModerator)  
        // comment console console.log('id data '+data)
        // comment console console.log(data)
        var idElement =  element.idModerator;
        var idSelect = data;
        if(idElement == idSelect) {
          status_invalid_form += 1;
          status_invalid_data += 1;
        }
      });

      if(status_invalid_form > 0) {
        this.alertError("Tidak Boleh Ada Moderator Yang Sama");
        this.formData.pelatihanModerator[k].idModerator = ''
        this.formData.pelatihanModerator[k].modelMultiSelect = []
        return false
      }
      if(status_invalid_data > 0) {
        this.alertError(" Moderator Dan Instruktur Tidak Boleh Sama");
        this.formData.pelatihanModerator[k].idModerator = ''
        this.formData.pelatihanModerator[k].modelMultiSelect = []
        return false
      }

      this.cekInstruktur(data, k , "moderator");
    },

    getDataInstruktur() {
      var vm = this;
      InstrukturService.getInstrukturAll()
      .then(response => {
        vm.dat_instruktur = response.data.data;
      })
      .catch(error => {
        // comment console console.log(error);
      });
    },

    getDataKatalog() {
      var vm = this;
      WorkshopService.getKatalog()
      .then(response => {
        vm.dat_katalog = response.data.data.content;
      })
      .catch(error => {
        // comment console console.log(error);
      });
    },

    getDataPenyelenggara() {
      var vm = this;
      PenyelenggaraService.getPenyelenggaraAll()
      .then(response => {
        vm.penyelenggara = response.data.data.content;
      })
      .catch(error => {
        // comment console console.log(error);
      });
    },

    getDataSignature() {     
      SignatureService.getSignature()
        .then(response => {
          this.dataSignature = response.data.content;
        })
        .catch(error => {
          // comment console console.log(error)
        });
    },

    postData() {
      this.$v.$touch();
      if(this.formData.flyer == '') {
        this.alertError("Flyer Harus Diisi");
        return false;
      }
      if(this.$v.formData.tanggalPengumumanSkp.$error) {
        return false
      }
      this.insertData(this.formData);
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });      

      var vm = this;
      this.formData.file
      
      formData.pelatihanMateri.forEach(element => {
        if (typeof element.fileMateri === "string") {
          delete element.fileMateri;
        }
        if (formData.file === null) {
          delete fileMateri.fileMateri;
        }  
        if (typeof formData.linkWebinar === "string") {
        delete formData.linkWebinar;
        }
        if (formData.file === null) {
          delete formData.linkWebinar;
        }
      });
      WorkshopService.postWorkshopUrl(formData)
      .then(response => {
        loader.hide();
        vm.myModal = false;
        vm.alertSuccess();
        vm.$router.push({ path: "/pelatihan/daftar-pelatihan/offline" });
      })
      .catch(error => {
        console.log(error.response)
        loader.hide();
        // comment console console.log(error);
      });
    },

    tipe_biaya(e) {
      // comment console console.log(e.target.value);
      if (e.target.value === "gratis") {
        this.statusBayar = false;
      } else if (e.target.value === "berbayar") {
        this.statusBayar = true;
      }
    },

    add(index) {
      var data =  this.formData.pelatihanKatalog;
      var katalog = [];
      data.filter(function(element,index) {
        katalog.push({
          idKatalog : '',
          skpTerstrukturKatalog : '',
          skpNonTerstrukturKatalog : ''
        })
      })

      this.formData.pelatihanInstruktur.push({
        idDatInstrukturPelatihan: "",
        idInstrukturPelatihan: "",
        skpAssesment: 0,
        skpNonTerstruktur: 0,
        showKatalog : false,
        skpTerstruktur: 0,
        modelMultiSelect : [],
        katalogInstruktur : katalog
      });

    },

    remove(index) {
      this.formData.pelatihanInstruktur.splice(index, 1);
    },

    add_dokumen(index) {
      this.formData.pelatihanDokumen.push({
        contoh_dokumen: "",
        kode_dokumen: "",
        nama_dokumen: "",
        statusRequired : "",
        fileName: "",
        idMasterDokumenPendukung: "",
        invalid_dokumen: false,
      });
    },

    remove_dokumen(index) {
      this.formData.pelatihanDokumen.splice(index, 1);
    },

    add_jadwal(index) {
      this.formData.jadwalPelatihanRequest.push({
        tanggalPelaksanaan : '',
        waktuDimulai : '',
        waktuBerakhir : ''
      });
      // comment console console.log(this.pelatihanMateri);
    },

    remove_jadwal(index) {
      this.formData.jadwalPelatihanRequest.splice(index, 1);
    },

    add_pengaturan_asessment(index) {
      this.formData.pengaturanAssessment.push({
        rangeSatu : '',
        rangeDua : '',
        assessment : ''
      });
    },

    remove_pengaturan_asessment(index) {
      this.formData.pengaturanAssessment.splice(index, 1);
    },

    add_materi(index) {
      this.formData.pelatihanMateri.push({
        idPelatihanMateri : '',
        fileMateri : '',
        fileName : '',
        namaMateri : ''
      });
      // comment console console.log(this.pelatihanMateri);
    },

    remove_materi(index) {
      this.formData.pelatihanMateri.splice(index, 1);
    },

    add_moderator(index) {
      var data =  this.formData.pelatihanKatalog;
      var katalog = [];
      data.filter(function(element,index) {
        katalog.push({
          idKatalog : '',
          skpTerstrukturKatalog : '',
          skpNonTerstrukturKatalog : ''
        })
      })
      this.formData.pelatihanModerator.push({
        idDatModeratorPelatihan: "",
        namaModerator: "",
        skpAssesment: 0,
        idModerator : '',
        skpNonTerstruktur: 0,
        skpTerstruktur: 0,
        showKatalog : false,
        katalogModerator : katalog,
        modelMultiSelect : [],
      });
      // comment console console.log(this.moderator);
    },

    remove_moderator(index) {
      this.formData.pelatihanModerator.splice(index, 1);
    },

    add_katalog(index) {
      this.formData.pelatihanKatalog.push({
        idDatKatalogPelatihan: "",
        idKatalogPelatihan: "",
        namaKatalog : '',
        skpAssesment: 0,
        skpNonTerstruktur: 0,
        skpTerstruktur: 0,
        katalogModel : []
      });
      var vm = this
      
    },

    remove_katalog(index) {
      this.formData.pelatihanKatalog.splice(index, 1);
    
    },

    getKotaKab() {
      var vm = this;
      KotaKabupatenService.getAll()
      .then(response => {
        // comment console console.log(response.data.data.content);
        vm.KotaKab = response.data.data.content;
      })
      .catch(error => {
        // comment console console.log(error);
      });
    },

    updateSelect(event) {
      var vm = this;      
      this.formData.idKotaKab = event.id_kota_kab
      this.formData.kotaKab = event;
    },

    selectSignature(value) {
      this.formData.idTandaTangan = value.idSignature
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>